import type { ChatMessage } from 'src/hooks/useChatSources';
import type { ConversationSummary } from './ConversationList/ConversationListItem';

// One message in a conversation, from the customer or the AI.
export interface ConversationMessage extends ChatMessage {
  _id: string;
  body: string;
  owner?: string;
  created_at?: string;
  metadata?: { last_called_tool?: string };
}

// A conversation with its messages, as the chat view shows it.
export interface Conversation extends ConversationSummary {
  updated_at?: string;
  // Why an escalated conversation escalated; one of the ESCALATION_REASONS values.
  escalation_reason_category?: string;
  messages: ConversationMessage[];
}

// What identifies a conversation in the list.
export const conversationKey = (chat: ConversationSummary) => chat.id || chat._id;
